module.exports = __webpack_public_path__ + "static/img/Frame_05.bf10f1ee.svg";